import { FormControl } from '@angular/forms';

export class ValidationRule {

    // data members

    get isValid() {
        return this._formControl.valid;
    }

    private _isModified = false;
    get isModified() {
        return this._isModified;
    }

    private _oldValue: any;
    get oldValue() {
        return this._oldValue;
    }

    private _newValue: any;
    get newValue() {
        return this._newValue;
    }

    private _name: string;
    get name() {
        return this._name;
    }

    private _element: any;
    get element() {
        return this._element;
    }

    private _initialState: any;
    private _formControl: FormControl;

    // constructor

    constructor(name: string, formControl: FormControl, initialState?: any) {

        this._name = name;
        this._formControl = formControl;
        this._initialState = initialState;

        this._oldValue = this._initialState;
        this._newValue = this._initialState;

        this._formControl.valueChanges.subscribe(value => {
            this._isModified = this._initialState != value;

            this._oldValue = this._newValue;
            this._newValue = value;
        });
    }

    // public functions

    resetValueState() {
        this._oldValue = this._newValue;
    }

    registerElement(element: any) {
        this._element = element;
    }
}

export class ValidationChanges {

    // data members

    private _changedValidationRule: ValidationRule;
    get changedValidationRule() {
        return this._changedValidationRule;
    }

    private _isValid = false;
    get isValid() {
        return this._isValid;
    }

    private _isModified = false;
    get isModified() {
        return this._isModified;
    }

    private _model: any;
    get model() {
        return this._model;
    }

    // constructor

    constructor(changedValidationRule: ValidationRule, isValid: boolean, isModified: boolean, model?: any) {

        this._changedValidationRule = changedValidationRule;
        this._isValid = isValid;
        this._isModified = isModified;
        this._model = model;

        this.changedValidationRule.resetValueState();
    }
}
